import React, { useEffect, useState } from 'react';
import { useScrolledToEnd } from '../../hooks/useScrolledToEnd';
import { useProgress } from '../hooks/useProgress';
import { usePreferences } from '../state/usePreferences';
import TickBox from './TickBox';
const PLANNING = [{
  n: '01',
  head: 'Portrait session',
  text: 'Give your portrait session enough time. Around an hour is ideal, thirty minutes the minimum. Less time means the standard shots only, and less opportunity to get the full creative set you shared.'
}, {
  n: '02',
  head: 'Interview slot',
  text: 'Plan a clear slot for interviews so they are not squeezed between events.'
}, {
  n: '03',
  head: 'Light and timing',
  text: "Remember the day's light and timing decide what is possible."
}];
const SubmitGate = ({
  open,
  onClose,
  onSubmit
}) => {
  const {
    submit,
    locked,
    goTo,
    sections
  } = usePreferences();
  const {
    allComplete,
    incompleteLabels
  } = useProgress();
  const {
    ref,
    reachedEnd,
    onScroll
  } = useScrolledToEnd(open);
  const [ack, setAck] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  // A refusal names the sections as they were when it was refused. The sheet
  // stays mounted while the client goes back and fills them, so without this
  // they return to a list they have already dealt with and have to reload to
  // be rid of it.
  useEffect(() => {
    if (open) setError(null);
  }, [open]);

  // The server names incomplete sections by title; the flow navigates by key.
  const sectionFor = title => sections.find(s => s.title === title)?.key;
  if (!open || locked) return null;
  return React.createElement("div", {
    className: "cp-planscrim",
    onClick: onClose
  }, React.createElement("div", {
    className: "cp-plansheet",
    onClick: e => e.stopPropagation()
  }, React.createElement("div", {
    className: "cp-planhead"
  }, React.createElement("div", null, React.createElement("p", {
    className: "cp-planeyebrow"
  }, "Before you finish"), React.createElement("p", {
    className: "cp-plantitle"
  }, "A quick planning note")), React.createElement("button", {
    type: "button",
    className: "cp-planx",
    onClick: onClose,
    "aria-label": "Close"
  }, React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round"
  }, React.createElement("path", {
    d: "M18 6L6 18M6 6l12 12"
  })))), React.createElement("div", {
    className: "cp-planbody",
    ref: ref,
    onScroll: onScroll
  }, React.createElement("p", {
    className: "cp-planlead"
  }, "Good planning is the one part in your control that gives us the best chance of capturing what you want. Time is one factor, the conditions of your day are another. The more you plan for, the more opportunity we have, though your actual day always shapes what is possible."), React.createElement("div", {
    className: "cp-plangrid"
  }, PLANNING.map(p => React.createElement("div", {
    className: "cp-plancard",
    key: p.n
  }, React.createElement("p", {
    className: "cp-plannum"
  }, p.n), React.createElement("p", {
    className: "cp-planhead-sm"
  }, p.head), React.createElement("p", {
    className: "cp-plantext"
  }, p.text)))), React.createElement("p", {
    className: `cp-plannote${allComplete ? ' is-ok' : ''}`
  }, allComplete ? 'All sections complete.' : `Still open: ${incompleteLabels.join(', ')}. You can submit as is, or go back and complete them.`)), error && React.createElement("div", {
    className: "cp-submiterror"
  }, error.code === 'sections_incomplete' && error.pendingSections?.length ? React.createElement(React.Fragment, null, React.createElement("p", {
    className: "cp-submiterror-head"
  }, "Still to complete: ", error.pendingSections.join(', '), "."), sectionFor(error.pendingSections[0]) && React.createElement("button", {
    type: "button",
    className: "cp-ghost",
    onClick: () => {
      goTo(sectionFor(error.pendingSections[0]));
      onClose();
    }
  }, "Go to ", error.pendingSections[0])) : React.createElement("p", {
    className: "cp-submiterror-head"
  }, error.message)), ack && React.createElement("div", {
    className: "cp-ackdisclaimer"
  }, React.createElement("p", {
    className: "cp-ackdisclaimer-head"
  }, "Please note"), React.createElement("p", {
    className: "cp-ackdisclaimer-body"
  }, "Once submitted, your responses cannot be edited")), React.createElement("div", {
    className: "cp-planfoot"
  }, React.createElement("button", {
    type: "button",
    className: `cp-ackrow${ack ? ' is-on' : ''}`,
    disabled: !reachedEnd,
    onClick: () => setAck(v => !v)
  }, React.createElement(TickBox, {
    checked: ack
  }), React.createElement("span", null, reachedEnd ? 'I acknowledge' : 'Scroll to the end to continue')), React.createElement("button", {
    type: "button",
    className: `cp-confirm${ack ? ' is-on' : ''}`,
    disabled: !ack || busy,
    onClick: () => {
      setBusy(true);
      setError(null);
      // Every failure here is permanent, so there is no retry.
      Promise.resolve(submit(ack === true)).then(onSubmit).catch(err => setError(err)).finally(() => setBusy(false));
    }
  }, "Submit preferences"))));
};
export default SubmitGate;
